module.exports = __webpack_public_path__ + "img/jdLogo.009f3f0c.png";